import api from '../../config/axios.js';

const state = {
    payment: {},
    errorPayment: "",
    successPayment: "",
    billing: {
        "month": "Carregando...",
        "number_of_cams": "Carregando...",
        "total_value": "Carregando...",
        "installations": "Carregando...",
        "categories": [
            "Carregando..."
        ],
        "enable_payment": false
    },
    pendingInvoice: [],
    errorSummary: "",
    errorPaymentModeDefault: "",
    paymentModeDefault: null,
    loadingPaymentMode: true,
    errorPaymentHistory: "",
    paymentHistory: [],
    paymentMethod: ["credit_card"]
}
const getters = {
    getPayment: state => state.payment,
    getErrorPayment: state => state.errorPayment,
    getSuccessPayment: state => state.successPayment,
    getBilling: state => state.billing,
    getPendingInvoice: state => state.pendingInvoice,
    getErrorBilling: state => state.errorBilling,
    getErrorPaymentModeDefault: state => state.errorPaymentModeDefault,
    getPaymentModeDefault: state => state.paymentModeDefault,
    getLoadingPaymentMode: state => state.loadingPaymentMode,
    getErrorPaymentHistory: state => state.errorPaymentHistory,
    getPaymentHistory: state => state.paymentHistory,
    getPaymentMethod: state => state.paymentMethod
}
const actions = {
    // REALIZANDO A CRIAÇÃO DA ASSINATURA DE PAGAMENTO
    async setProcessSubscriptionPayment({ commit }, data) {
        await api.axios.post('/api/checkout/process', data).catch(error => {
            if(error && error.response && error.response.data && error.response.data){
                commit("setErrorPayment", error.response.data);
            }

        }).then(function(response){
            if(response && response.status == 200){
                commit('setSuccessPayment', "pagamento confirmado, o serviço já está disponibilizado !");
                location.reload();
            }
        });
    },
    // REALIZANDO O PAGAMENTO COM CARTÃO DE CRÉDITO
    async setProcessPaymentCreditCard({ commit }, data) {
            try {
                // Limpa mensagem de erro anteriormente
                commit("setErrorPayment", "");
                
                const response = await api.axios.post('/api/create/subscription', data);
                
                if(response && response.status == 200){
                    commit('setSuccessPayment', "Pagamento confirmado com sucesso!");
                    setTimeout(() => {
                        location.reload();
                    }, 1000);
                }
            } catch (error) {
                if(error && error.response && error.response.data){
                    commit("setErrorPayment", error.response.data);
                } else {
                    commit("setErrorPayment", "Erro ao processar pagamento. Tente novamente mais tarde.");
                }
            }
    },
    
    // REALIZANDO O PAGAMENTO COM BOLETO
    async setProcessPaymentBoleto({ commit }) {
        await api.axios.post('/api/create/payment/boleto', {}).catch(error => {
            if(error && error.response && error.response.data && error.response.data){
                commit("setErrorPayment", error.response.data);
            }
        }).then(function(response){
            if(response && response.status == 200){
                commit('setSuccessPayment', "Boleto gerado com sucesso! Verifique seu e-mail.");
                setTimeout(() => {
                    location.reload();
                }, 1000);
            }
        });
    },
    
    // DEFINIR MÉTODO DE PAGAMENTO
    setPaymentMethod({ commit }, method) {
        commit('setPaymentMethod', method);
    },
    
    // BUSCANDO CONFIGURAÇÕES DE PAGAMENTO
    async setPaymentModeDefault({ commit }) {
        await api.axios.get('/api/payment-mode').then(function(response){
            if(response && response.status == 200){
                commit('setPaymentModeDefault', response.data);
            }
        });
    },
    // ZERANDO MENSAGEM DE ERRO NO PROCESSAMENTO DE PAGAMENTO
    setResetErrorPayment({ commit }){
        commit("setErrorPayment", "");
    },
    
    // DEFININDO MENSAGEM DE ERRO NO PAGAMENTO
    setErrorPayment({ commit }, message) {
        commit("setErrorPayment", message);
    },
    
    // DEFININDO MENSAGEM DE SUCESSO NO PAGAMENTO
    setSuccessPayment({ commit }, message) {
        commit("setSuccessPayment", message);
    },
    
    // BUSCANDO O DÉBITO DO CLIENTE
    async setBilling({ commit }) {
        await api.axios.get('/api/billing').catch(function(){
            
            commit("setErrorBilling", "Erro ao buscar informações de pagamento, por favor tente novamente mais tarde !");

        }).then(function(response){
            if(response.status == 200){
                commit('setBilling', response.data);
            }
        });
    },
    // BUSCANDO A QUANTIDADE DE DIAS QUE OS ARQUIVOS FICARAM NA NUVEM APÓS O CANCELAMENTO DO SERVIÇO
    async setDaysExportFiles({ commit }) {
        await api.axios.get('/api/export/files/finish').catch(function(){
            
            commit("setDaysExportFiles", 10);

        }).then(function(response){
            if(response && response.status == 200){
                commit('setDaysExportFiles', response.data);
            }
        });
    },
    // BUSCANDO O VALOR DO SERVIÇO
    async setServicePrice({ commit }) {
        await api.axios.get('/api/service/price').catch(function(){
            
            commit("setServicePrice", false);

        }).then(function(response){
            if(response && response.status == 200){
                commit('setServicePrice', response.data);
            }
        });
    },
    // BUSCANDO HISTÓRICO DE PAGAMENTOS DO CLIENTE
    async setInvoices({ commit }, data) {

        await api.axios.post('/api/invoices', data).catch(function(){

            commit("setErrorPaymentHistory", "Erro ao buscar histórico de pagamentos do cliente, por favor tente novamente mais tarde !");

        }).then(function(response){
            if(response && response.status == 200){
                commit('setPaymentHistory', response.data);
            }
        });
    },
    // BUSCANDO O PRÓXIMO PAGAMENTO DO CLIENTE
    async setPendingInvoice({ commit }, data) {
        await api.axios.post('/api/pending/invoice', data).catch(function(){
            
            // commit("setErrorPendingInvoice", "Erro ao buscar histórico de pagamentos do cliente, por favor tente novamente mais tarde !");

        }).then(function(response){
            if(response && response.status == 200){
                commit('setPendingInvoice', response.data);
            }
        });
    },
}
const mutations = {
    setProcessSubscriptionPayment: function(state, data){
        state.payment = data;
    },
    setErrorPayment: function(state, data){
        state.errorPayment = data;
    },
    setSuccessPayment: function(state, data){
        state.successPayment = data;
    },
    setErrorBilling: function(state, data){
        state.errorBilling = data;
    },
    setBilling: function(state, data){
        state.billing = data;
    },
    setErrorPaymentModeDefault: function(state, data){
        state.errorPaymentModeDefault = data;
    },
    setPaymentModeDefault: function(state, data){
        state.paymentModeDefault = data;
    },
    setLoadingPaymentMode: function(state, data){
        state.loadingPaymentMode = data;
    },
    setErrorPaymentHistory: function(state, data){
        state.errorPaymentHistory = data;
    },
    setPaymentHistory: function(state, data){
        state.paymentHistory = data;
    },
    setDaysExportFiles: function(state, data){
        state.daysExportFiles = data;
    },
    setServicePrice: function(state, data){
        state.servicePrice = data;
    },
    setGbFree: function(state, data){
        state.gbFree = data;
    },
    setPendingInvoice: function(state, data){
        state.pendingInvoice = data;
    },
    setPaymentMethod: function(state, data){
        state.paymentMethod = data;
    }
}
export default {
    state,
    getters,
    actions,
    mutations
}